import React from 'react';

import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { BottomSheetPortal } from 'components/bottom-sheet/bottom-sheet-portal';

const PromptContainer = styled.div`
  background: #fff;
  border-radius: 8px;
  padding: 1.5rem;
  text-align: center;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
`;

const Header = styled.h2`
  margin: 0;
  color: #3c1e1e;
  font-family: ${Styles.fontFamily.base};
  font-weight: 400;
  font-size: 1.5rem;
`;

const SubText = styled.p`
  color: #3c1e1e;
  margin-block-start: 0.5rem;
  margin-block-end: 1.5rem;
  margin-inline: 0;
  font-size: 1rem;
  font-family: ${Styles.fontFamily.body};
  font-weight: 300;
  line-height: 1.3;
  max-width: 80%;
  margin-inline-start: auto;
  margin-inline-end: auto;
`;

const AllowButton = styled.button`
  background: #b82019;
  color: #ffffff;
  font-size: 1rem;
  font-weight: 600;
  border: none;
  border-radius: 9999px;
  padding: 0.9rem 1.5rem;
  width: 100%;
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(184, 32, 25, 0.25);
  font-family: ${Styles.fontFamily.base};
  &:hover {
    background: #991d14;
  }
`;

interface AllowNotificationPromptProps {
  onAllow: () => void;
  onClose: () => void;
}

export const AllowNotificationPrompt: React.FC<AllowNotificationPromptProps> = ({
  onAllow,
  onClose,
}) => {
  const { formatMessage } = useIntl();

  return (
    <BottomSheetPortal
      showBottomSheet={true}
      title=""
      drawerPositionOffset={0}
      onCalculatePreviewHeight={() => {}}
      defaultExpanded={true}
      bottomSheetContent={
        <PromptContainer>
          <Header>{formatMessage({ id: 'allowNotificationHeader' })}</Header>
          <SubText>{formatMessage({ id: 'allowNotificationSubText' })}</SubText>
          <AllowButton onClick={onAllow}>
            {formatMessage({ id: 'allowNotificationButton' })}
          </AllowButton>
        </PromptContainer>
      }
      onClose={onClose}
    />
  );
};
